import UserConsoleLayout from '@/views/kpi/layout/userConsoleLayout.vue';

/**
 * @import {RouteMeta} from "@/router/type.jsdoc"
 */

/**
 * 所有用户路由表
 * @type {RouteMeta[]}
 */
export const authorRoutes = [
    {
        path: '',
        redirect: '/home',
        page: UserConsoleLayout,
    },
    {
        title: '个人信息',
        path: '/account/base-info',
        page: () => import('@/views/common/account/base-info/base-info.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user', 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '账号', '个人信息' ],
        icon: [ 'vxe-icon-user', '' ],
        menuOrder: 0,
    },
    {
        title: '修改密码',
        action: 'change-password',
        requireAuth: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        menu: [ '账号', '修改密码' ],
        icon: [ 'vxe-icon-user', 'vxe-icon-lock' ],
        menuOrder: 998,
    },
    {
        path: `/org-login/:orgId`,
        page: () => import('@/views/common/account/org-sign-in/org-sign-in.vue'),
        props: true,
        title: '登录组织单位中心',
        visible: false,
        roles: [ 'user' ],
        requireAuth: true,
        closable: false,
    },
    {
        title: '退出登录',
        action: 'sign-out',
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        menu: [ '账号', '退出登录' ],
        icon: [ 'vxe-icon-user', 'fa fa-sign-out' ],
        menuOrder: 999,
    },
    {
        title: '行业项目指标库',
        path: '/kpi/proj-kpi/declare/indu-kpi-search',
        page: () => import('@/views/kpi/kpi-build/indu-proj-kpi-search/indu-proj-kpi-search.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user', 'org-user', 'org-admin', 'org-creator' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效学习', '行业项目指标库' ],
        icon: [ 'vxe-icon-sunny', '' ],
    },
    {
        title: '行业部门指标库',
        path: '/kpi/dep-kpi/declare/indu-kpi-search',
        page: () => import('@/views/kpi/kpi-build/indu-dep-kpi-search/indu-dep-kpi-search.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user', 'org-user', 'org-admin', 'org-creator' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效学习', '行业部门指标库' ],
        icon: [ 'vxe-icon-sunny', '' ],
    },
    {
        title: '行业绩效指标表',
        path: '/kpi/proj-kpi/declare/indu-kpi-table/:kpiId',
        page: () => import('@/views/kpi/kpi-build/indu-kpi-table/indu-kpi-table.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'user', 'org-user', 'org-admin', 'org-creator' ],
        requireAuth: true,
    },
    {
        path: '/kpi/proj-kpi/declare/kpi-table/:projId',
        page: () => import('@/views/kpi/kpi-build/proj-kpi-item/proj-kpi-table.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        title: '项目绩效申报表',
        roles: [ 'user', 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: 'AI生成指标项',
        path: '/kpi/proj-kpi/ai-create-items/:projId',
        page: () => import('@/views/kpi/kpi-build/proj-kpi/ai-create-kpi-items.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '使用AI创建绩效目标表',
        path: '/kpi/proj-kpi/declare/create-by-ai',
        page: () => import('@/views/kpi/kpi-build/proj-kpi/create-by-ai.vue'),
        roles: [ 'user', 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: false,
        closable: true,
    },
    {
        title: 'AI生成项目支出绩效自评报告',
        path: '/kpi/proj-kpi/appraise/create-appraise-report-ai',
        page: () => import('@/views/kpi/kpi-appraise/proj-appraise/create-appraise-report-by-ai/create-appraise-report-ai.vue'),
        props: true,
        roles: [ 'user', 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '导入绩效表(标准)',
        path: '/kpi/proj-kpi/declare/import-sys-proj-kpi-wizard',
        page: () => import('@/views/kpi/kpi-build/proj-kpi/import-sys-proj-kpi-wizard.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user', 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '导入绩效表(一体化)',
        path: '/kpi/proj-kpi/declare/import-proj-kpi-wizard',
        page: () => import('@/views/kpi/kpi-build/proj-kpi/import-proj-kpi-wizard.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user', 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        history: true,
        closable: true,
    },
    {
        title: '导入项目信息(一体化)',
        path: '/kpi/proj-kpi/declare/import-project-wizard',
        page: () => import('@/views/kpi/kpi-build/proj-kpi/import-project-wizard.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'user', 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        history: true,
        closable: true,
    },
];
